import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { PatientAllergyService } from '@service/patient-facesheet/patient-allergy.service';
import { DatePipe } from '@angular/common';
import { PatientCardDetail } from '@models/appointments/patient.model';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';

@Component({
  selector: 'app-cardinfo-dialog',
  templateUrl: './claimpayment.component.html',
  styleUrls: ['./claimpayment.component.css']
})
export class ClaimPaymentDialogComponent {
  cardDetail: Array<PatientCardDetail>;
  checkboxList: boolean[] = [];
  selectedTotalAmount: number = 0;
  amount: number = 0;
  totalDueAmount = 0;
  proceedClicked: boolean = false;
  patientpayment = { Amount: 0 };
  paymentOption: string = 'Pay_Custom';
  selectAllChecked: boolean = true;
  paymentForm: FormGroup;
  PaymentOption = BeyondEMRConstants.PaymentOption;

  constructor(
    public dialogRef: MatDialogRef<ClaimPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public patientAllergyService: PatientAllergyService,
    private fb: FormBuilder,
    private datePipe?: DatePipe
  ) {
    // Set the defaults
    
    this.paymentForm = this.fb.group({
      amount: [
        '',
        [
          Validators.required,
          Validators.min(1),
          this.maxTotalDueValidator.bind(this)
        ]
      ]
    });
    this.paymentForm.get('amount').valueChanges.subscribe(value => {
      this.paymentForm.get('amount').updateValueAndValidity();
    });
    this.cardDetail = data.cardDetail;
    this.amount = data.amount;
    dialogRef.disableClose = true;
    this.checkboxList = Array(data.patientsToPay.length).fill(true);
  }
  proceed(): void {
    this.proceedClicked = true;
  }

  maxTotalDueValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value < 0) {
      return { negativeAmount: true };
    }
    if (control.value && control.value > this.totalDueAmount) {
      return { maxTotalDue: true };
    }
    return null;
  }

  get amountErrors() {
    const control = this.paymentForm.get('amount');
    if (control.hasError('negativeAmount')) {
      return 'Amount cannot be negative.';
    }
    if (control.hasError('min')) {
      return 'Amount must be greater than 0.';
    }
    if (control.hasError('maxTotalDue')) {
      return `Amount cannot exceed total due amount of $${this.totalDueAmount}.`;
    }
    return null;
  }

  ngOnInit() {
    this.updateTotalDueAmount();
  }

  updateSelectAll() {
    this.selectAllChecked = this.checkboxList.every(checked => checked);
  }

  goBack(): void {
    this.proceedClicked = false;
  }

  payCustom() {
    const item = [];
    const details = [];
    let amount: number = +this.paymentForm.get('amount')?.value;
    const PaymentOptionId = this.PaymentOption[this.paymentOption];
    this.data.patientsToPay.forEach(patient => {
      item.push(patient.Id);
      details.push({ Id: patient.Id, Amount: amount });
    });
    const totalBalance = +this.paymentForm.get('amount')?.value; 
    this.dialogRef.close({ totalBalance, PaymentOptionId });
  }

  pay() {
    const item = [];
    const totalPatientBalance = [];
    const details = [];
    const PaymentOptionId = this.PaymentOption[this.paymentOption];
    this.checkboxList.forEach((isChecked, index) => {
      if (isChecked) {
        item.push(this.data.patientsToPay[index].Id);
        totalPatientBalance.push(this.data.patientsToPay[index].PatientBalance);
        details.push({ Id: this.data.patientsToPay[index].Id, Amount: this.data.patientsToPay[index].PatientBalance });
      }
    });
    const totalBalance = totalPatientBalance.reduce((sum, amount) => sum + amount, 0);
    this.dialogRef.close({ item, totalBalance, details, PaymentOptionId });
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  toggleSelectAll() {
    const allChecked = this.checkboxList.every(checked => checked);
    this.checkboxList.fill(!allChecked);
  }

  updateTotalDueAmount() {
    let totalAmount = 0;
    this.data.patientsToPay.forEach(item => {
      totalAmount += item.PatientBalance;
    });
    this.totalDueAmount = Number(totalAmount.toFixed(2));
  }


  getSelectedTotalAmount() {
    let totalAmount = 0;
    this.checkboxList.forEach((isChecked, index) => {
      if (isChecked) {
        totalAmount += this.data.patientsToPay[index].PatientBalance;
      }
    });
    return Number(totalAmount.toFixed(2));
  }

  payUsingNewCard() {
    this.dialogRef.close("NEW");
  }
}
